import React from 'react';
import {Button, Stack, Typography} from '@mui/material';

import {Modal as ModalComponent} from 'presentation/components/Modal';
import {IconIllustration} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import {ModalProps} from './types';

const {cancel, exclude} = translations['pt-br'].commons;
export const ConfirmActionModal = ({
	open,
	setOpen,
	onConfirm,
	title,
	text,
	description,
}: ModalProps) => (
	<ModalComponent.Root open={open} onClose={() => setOpen(false)}>
		<ModalComponent.Header title={title} onClose={() => setOpen(false)} />
		<Stack justifyContent="center" direction="row" mt={3}>
			<IconIllustration variant="info" />
		</Stack>
		<ModalComponent.Content>
			<Typography variant="h6" textAlign="center">
				{text}
			</Typography>
			<Typography variant="body1" marginTop={2} textAlign="center">
				{description}
			</Typography>
		</ModalComponent.Content>

		<ModalComponent.Footer>
			<Stack spacing={1} direction="row" width="100%">
				<Button fullWidth variant="outlined" onClick={() => setOpen(false)}>
					{cancel}
				</Button>
				<Button fullWidth variant="outlined" color="error" onClick={onConfirm}>
					{exclude}
				</Button>
			</Stack>
		</ModalComponent.Footer>
	</ModalComponent.Root>
);
